import { rechargeApiRequest, getInternalSession } from '../utils/request.js';

async function getOrder(session, id) {
  if (id === void 0 || id === "") {
    throw new Error("ID is required");
  }
  const { order } = await rechargeApiRequest(
    "get",
    `/orders`,
    {
      id
    },
    getInternalSession(session, "getOrder")
  );
  return order;
}
function listOrders(session, query) {
  return rechargeApiRequest("get", `/orders`, { query }, getInternalSession(session, "listOrders"));
}
async function delayOrder(session, id) {
  if (id === void 0 || id === "") {
    throw new Error("ID is required");
  }
  const { order } = await rechargeApiRequest(
    "post",
    `/orders/${id}/delay`,
    {},
    getInternalSession(session, "delayOrder")
  );
  return order;
}

export { delayOrder, getOrder, listOrders };
//# sourceMappingURL=order.js.map
